export default __webpack_public_path__ + "static/media/TravelMap.9af70a63.png";